import WithSidebar from "../../../layouts/WithSidebar"
import { ajax } from "../../../scripts/helper"
import utils from "../../../scripts/utils"
import { useSnackbar } from 'notistack'
import { useEffect, useState } from "react"
import PosForm from "../../../components/Pos-form"
import { useSearchParams } from "react-router-dom"


const PosPayment = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const id = searchParams.get("id")




    return(
        <WithSidebar pageTitle={'Create POS Payment'} breadcrumb={'Dashboard > Payment > POS'}>
            <PosForm edit={(id ? id: null)}/>
        </WithSidebar>
    )
}

export default PosPayment